import React from "react";

import "../Styles/aboutme.css";

const AboutMe = () => {
  return (
    <div className="about-me" id="about-me">
      <h2>Hi there, I'm Hope! I'm a self taught web developer</h2>
      <p className="about-me-p">
        I am fascinated by turning ideas into beautiful, interactive pages. The
        creation process is so fulfilling to me, and I live for the moments when
        I face a difficult problem and then finally find the solution that makes
        it work!
      </p>
      <br />
      <p className="about-me-p">
        When I am not immersed in trying how to center a div, I enjoy painting,
        interior decorating, reading fantasy books, tending to my plants,
        annoying my husband and trying to put together an all white puzzle.
      </p>
    </div>
  );
};

export default AboutMe;
